export default "/static/media/icon-instagram.ec3d0282.svg";